import React from "react";
import AttributeValue from "@imminently/decisively-ui/AttributeValue";
import { useGraphVisualisation } from "@/components/GraphVisualisation/hooks/useGraphVisualisation";
import { isFeatureEnabled } from "@/config";

/**
 * @deprecated - use AttributeValue instead
 */
const NodeValue = ({
  node,
  showType = true,
  hideTemporal = false,
  temporalType = "bar",
  labelProps = {}
}) => {
  const { temporalSlice } = useGraphVisualisation();
  const showReason = isFeatureEnabled("experimental.extended_debug_diagnostics");

  return (
    <AttributeValue
      node={node}
      showType={showType}
      hideTemporal={hideTemporal}
      temporalSlice={temporalSlice}
      labelProps={labelProps}
      showReason={showReason}
    />
  );
};

export default NodeValue;
